import { z } from 'zod';

/// //////////////////////////////////////////////////
/// Model
/// /////////////////////////////////////////////////

export const NotificationBadgeModel = z.object({
  comment: z.object({ unread: z.number() }),
  workflow: z.object({ actionRequired: z.number() }),
});
